export const initScroll = () => {
  // Select all links with hashes
$('.scroll-to')
.click(function(event) {
  // On-page links
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
    &&
    location.hostname == this.hostname
  ) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function() {
      });
    }
  }
});
}

export const addLeadingZero = val => ('0' + val).slice(-2);

export const af_utils = {
  /**
   * Get cookie by name helper
   * @param {String} name cookie name
   * @return {?String} cookie value
   */
  getCookie: function(name) {
    var matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));

    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  /**
   * Set cookie value helper
   * @param {String} c_name cookie name
   * @param {String} value cookie value
   * @param {Number} exdays cookie expires
   */
  setCookie: function(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + ';path=/';
  },

  /**
   * Parse query string to JSON helper
   * @param {String} str query string
   * @return {{} | null} parsed value
   */
  queryStringToJSON: function(str) {
    var pairs = str.split('&');
    var result = {};
    pairs.forEach(function (pair) {
      pair = pair.split('=');
      var name = pair[0];
      var value = pair[1];
      if (name.length)
        if (result[name] !== undefined) {
          if (!result[name].push) {
            result[name] = [result[name]];
          }
          result[name].push(value || '');
        } else {
          result[name] = value || '';
        }
    });
    return (result);
  }
};

/**
 * is Iphone 5s
 * @return {boolean}
 */
export function isIphone5(){
  function iOSVersion(){
    var agent = window.navigator.userAgent,
      start = agent.indexOf( 'OS ' );
    if( (agent.indexOf( 'iPhone' ) > -1) && start > -1)
      return window.Number( agent.substr( start + 3, 3 ).replace( '_', '.' ) );
    else return 0;
  }
  return iOSVersion() >= 6 && window.devicePixelRatio >= 2 && screen.availHeight == 568;
}
